import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_CURRENT_USER} from '@/graphql/queries/auth/current_user'
import {LOGIN_USER} from '@/graphql/mutations/auth/login'
import {LOGOUT_USER} from "@/graphql/mutations/auth/logout";
import {RESET_PASSWORD} from "@/graphql/mutations/auth/reset";
import {RETRIEVE_PASSWORD} from "@/graphql/mutations/auth/retrieve"

const state = {
  token: localStorage.getItem('auth-token'),
  user: {}
};

const getters = {
  isAuthenticated: state => !!state.token,
  user: state => state.user
};

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
    localStorage.setItem('auth-token', token)
  },
  SET_CURRENT_USER (state, user) {
    state.user = {...user}
  },
  CLEAR_TOKEN (state) {
    state.token = '' && localStorage.removeItem('auth-token')
  }
};

const actions = {
  async login ({commit, dispatch}, authDetails) {
    // try {
    const {data} = await apolloClient.mutate({mutation: LOGIN_USER, variables: {...authDetails}})
    const token = data.login.access_token;
    commit('SET_TOKEN', token)
    // dispatch('setUser')
    // } catch (e) {
    //   console.log(e)
    // }
  },
  async setCurrentUser ({commit}) {
    const {data} = await apolloClient.query({query: GET_CURRENT_USER})
    commit('SET_CURRENT_USER', data.me)
  },
  async logout ({dispatch}) {
    try {
      const {data} = await apolloClient.mutate({mutation: LOGOUT_USER})
    } catch (e) {

    }
    dispatch('logoutOffline')
  },
  async logoutOffline ({commit}) {
    commit('CLEAR_TOKEN')
  },
  async retrievePassword ({dispatch}, input) {
    const {data} = await apolloClient.mutate({mutation: RETRIEVE_PASSWORD, variables: {input: input}})
    if (data && data.retrievePassword && data.retrievePassword.status === 'EMAIL_SENT') {
      dispatch('setSuccessMessages', data.retrievePassword.message)
    }
  },
  async resetPassword ({dispatch}, input) {
    const {data} = await apolloClient.mutate({mutation: RESET_PASSWORD, variables: {input: input}})
    console.log(data)
    if (data && data.resetPassword && data.resetPassword.status === 'PASSWORD_UPDATED') {
      dispatch('setSuccessMessages', data.resetPassword.message)
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js